import { render, staticRenderFns } from "./FormGetEmail.vue?vue&type=template&id=1aa8c52a&scoped=true&"
import script from "./FormGetEmail.vue?vue&type=script&lang=js&"
export * from "./FormGetEmail.vue?vue&type=script&lang=js&"
import style0 from "./FormGetEmail.vue?vue&type=style&index=0&id=1aa8c52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8c52a",
  null
  
)

export default component.exports